import {Component, Input, ViewChild} from '@angular/core';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {
  GeschwisterDetailsFormComponent,
  GeschwisterFormData
} from '../../../../../shared/geschwister-details-form/geschwister-details-form.component';

export type GeschwisterStepData = GeschwisterFormData;

@Component({
  selector: 'app-geschwister-step',
  standalone: true,
  imports: [GeschwisterDetailsFormComponent],
  templateUrl: './geschwister-step.component.html',
})
export class GeschwisterStepComponent implements WizardStepComponent {

  @Input() ticketId: string;
  @Input() initialData: GeschwisterStepData | null;

  @ViewChild(GeschwisterDetailsFormComponent) private geschwisterForm: GeschwisterDetailsFormComponent;

  isValid(): boolean {
    return this.geschwisterForm.isValid();
  }

  getValue(): GeschwisterStepData {
    return this.geschwisterForm.getFormValue();
  }
}
